export const data = {
    title: "Accordion Style 02",
    items: [
        {
            id: 4,
            title: "How can we help your business?",
            description:
                "Through the collaboration with customers in discussing needs and demand, we're able to attain mutual understanding, gain customer trust to offer appropriate advice, and bring about suggestions on suitable technology to transform your business.",
        },
        {
            id: 5,
            title: "What are the advantages of Mitech?",
            description:
                "Mitech takes into consideration every little detail to make sure the system run smoothly and responsively. Mitech employs a new technique called Minified Technology for securing customers' database & building up highly confidential firewalls.",
        },
        {
            id: 6,
            title: "How working process is simplified?",
            description:
                "We reduce redundant complex calculations and lengthy erroneous code texts with simpler ones to ensure Mitech would run seamlessly and the design is reserved in its best form when viewed from a wide range of mobile devices & browsers.",
        },
        {
            id: 7,
            title: "Product Engineering & Services",
            description:
                "Our service offerings to enhance customer experience throughout the product lifecycle includes – test and repair, service management, and end-to-end warranty management.",
        },
    ],
};
